import { all, takeEvery, call, put } from 'redux-saga/effects';
import actions from './actions';
import SuperFetch from '../../helpers/superFetch';
import { apiUrls } from '../../settings';
import isEmpty from 'lodash/isEmpty';

// get property details
async function doGetPropertyDetails(hash) {
  return await SuperFetch.post(`${apiUrls.getProperty}?phash=${hash}`)
    .then(res => res)
    .catch(error => ({
      error: JSON.stringify(error)
    }));
}
function* getPropertyDetails(action) {
  const response = yield call(doGetPropertyDetails, action.payload);
  if ( response && response.property && !isEmpty(response.property) ) {
    yield put(actions.doGetPropertySuccess(response.property));
  } else {
    yield put(actions.doGetPropertyFailed({error: 'Failed to load property'}));
  }
}

// get invited tenants
async function doGetInvitedTenants() {
  return await SuperFetch.post(apiUrls.listTenants)
    .then(res => res)
    .catch(error => ({
      error: JSON.stringify(error)
    }));
}
function* getInvitedTenants(action) {
  const response = yield call(doGetInvitedTenants);
  if ( response && !isEmpty(response) && !response.error ) {
    yield put(actions.doGetInvitedTenantsSuccess(response));
  } else {
    yield put(actions.doGetInvitedTenantsFailed(response));
  }
}

// create AST
async function doCreateAst(payload) {
  const body = {
    data: payload
  }
  return await SuperFetch.post(apiUrls.createAstForLandlord, body)
    .then(res => res)
    .catch(error => ({
      error: JSON.stringify(error)
    }));
}
function* createAst(action) {
  const response = yield call(doCreateAst, action.payload);
  if ( response && !isEmpty(response) ) {
    yield put(actions.doCreateAstSuccess(response.ast));
  } else {
    yield put(actions.doCreateAstFailed(response));
  }
}

// get AST
async function doGetAst(hash, includeExtraData) {
  const url = `${apiUrls.getAstForLandlord}?hash=${hash}&&includeTenants=1&includeLandlord=1`
    + (includeExtraData ? '&includeDocument=1' : '');
  return await SuperFetch.post(url)
    .then(res => res)
    .catch(error => ({
      error: JSON.stringify(error)
    }));
}
function* getAst(action) {
  const response = yield call(doGetAst, action.payload, action.includeExtraData);
  console.log('response', response);
  if ( response && !isEmpty(response) && !response.error ) {
    yield put(actions.doGetAstSuccess(response));
  } else {
    console.log('running failed')
    yield put(actions.doGetAstFailed(response));
  }
}

// list TA agreements
async function doListTaAgreements() {
  return await SuperFetch.post(`${apiUrls.getAllAstList}`)
    .then(res => res)
    .catch(error => ({
      error: JSON.stringify(error)
    }));
}
function* listTaAgreements(action) {
  const response = yield call(doListTaAgreements);
  if ( response && response.asts && response.asts.length ) {
    yield put(actions.doListTaAgreementsSuccess(response.asts));
  } else {
    yield put(actions.doListTaAgreementsFailed(response));
  }
}

// update AST
async function doUpdateAst(hash, payload) {
  const body = {
    data: payload
  }
  return await SuperFetch.post(`${apiUrls.updateTenancyAgreement}?hash=${hash}`, body)
    .then(res => res)
    .catch(error => ({
      error: JSON.stringify(error)
    }));
}
function* updateAst(action) {
  const response = yield call(doUpdateAst, action.hash, action.payload);
  if ( response && !isEmpty(response) ) {
    yield put(actions.doUpdateAstSuccess(response));
  } else {
    yield put(actions.doUpdateAstFailed(response));
  }
}

// delete AST
async function doDeleteAst(hash) {
  const body = {
    data: {
      astHash: hash
    }
  }
  return await SuperFetch.post(`${apiUrls.landlordRemoveAst}`, body)
    .then(res => res)
    .catch(error => ({
      error: JSON.stringify(error)
    }));
}
function* deleteAst(action) {
  const response = yield call(doDeleteAst, action.payload);
  if ( response && !isEmpty(response) ) {
    yield put(actions.doDeleteAstSuccess(response));
    yield put(actions.doListTaAgreements());
  } else {
    yield put(actions.doDeleteAstFailed(response));
  }
}

// sign AST
async function doSignAst(hash) {
  return await SuperFetch.post(`${apiUrls.landlordSignTenancyAgreement}?hash=${hash}`)
    .then(res => res)
    .catch(error => ({
      error: JSON.stringify(error)
    }));
}
function* signAst(action) {
  const response = yield call(doSignAst, action.payload);
  if ( response && !isEmpty(response) ) {
    yield put(actions.doSignAstSuccess(response));
    yield put(actions.doGetAst(action.payload, true));
  } else {
    yield put(actions.doSignAstFailed(response));
  }
}

export default function* rootSaga() {
  yield all([
    takeEvery(actions.DO_GET_PROPERTY, getPropertyDetails),
    takeEvery(actions.DO_GET_INVITED_TENANTS, getInvitedTenants),
    takeEvery(actions.DO_CREATE_AST, createAst),
    takeEvery(actions.DO_GET_AST, getAst),
    takeEvery(actions.DO_UPDATE_AST, updateAst),
    takeEvery(actions.DO_DELETE_AST, deleteAst),
    takeEvery(actions.DO_SIGN_AST, signAst),
    takeEvery(actions.DO_LIST_TA_AGREEMENTS, listTaAgreements),
  ]);
}


// WEBPACK FOOTER //
// ./src/redux/propertiesTenancyAgreements/sagas.js